import { render, staticRenderFns } from "./DxzlzxHome.vue?vue&type=template&id=43e1d98d&scoped=true"
import script from "./DxzlzxHome.vue?vue&type=script&lang=js"
export * from "./DxzlzxHome.vue?vue&type=script&lang=js"
import style0 from "./DxzlzxHome.vue?vue&type=style&index=0&id=43e1d98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e1d98d",
  null
  
)

export default component.exports